import { cardsItems } from '@/mocks/anime';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精品动漫推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            编辑精选高分动漫作品，每一部都值得下载收藏
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cardsItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}